export default "__VITE_ASSET__BsTaT$hd__"